export default __webpack_public_path__ + "static/notebook-401f648d161152e551b024e304e70d50.webp";